import CrudRepository from './CrudRepository'
export default class AddNumVerifyRepository extends CrudRepository {
  constructor () {
    super('core/api/users/new/verify')
  }
}
